import * as React from 'react';
import {
	StyledBlurPanel,
	BlurPanelHeader,
	BlurPanelHeaderButton,
	BlurPanelHeaderLabel,
	BlurPanelContent,
	BlurPanelContentBackground,
} from './styles';
import { Translate } from 'react-redux-i18n';

export interface BlurPanelProps {
	isOpen: boolean;
	onCancelClick: () => void;
	onOkClick: () => void;
	children: React.ReactNode;
	label?: string;
}

const BlurPanel = ({ isOpen, onCancelClick, onOkClick, children, label }: BlurPanelProps) => (
	<StyledBlurPanel isOpen={isOpen}>
		<BlurPanelHeader>
			<BlurPanelHeaderButton
				isLeft={true}
				onClick={onCancelClick}
			>
				<Translate value="messages.cancel" />
			</BlurPanelHeaderButton>
			{label &&
				<BlurPanelHeaderLabel>
					<Translate value={label} />
				</BlurPanelHeaderLabel>
			}
			<BlurPanelHeaderButton
				isRight={true}
				onClick={onOkClick}
			>
				<Translate value="messages.ok" />
			</BlurPanelHeaderButton>
		</BlurPanelHeader>
		<BlurPanelContent>
			<BlurPanelContentBackground>
				{children}
			</BlurPanelContentBackground>
		</BlurPanelContent>
	</StyledBlurPanel>
);

export default BlurPanel;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/BlurPanel/index.tsx